import React, { useState, useEffect, useF } from "react";
import axios from "axios";
import moment from "moment";
import env from "../../config.json";
import { FaSpinner } from "react-icons/fa";
import {
  PackageDetails,
  DateStrip,
  PickupLocation,
  CruzeAndPartner,
} from "./components";
// import DateStrip from "./DateStrip";
// import PickupLocation from "./PickupLocation";
// import PersonCount from "../booking/NumberOfPersons";
// import CruzeAndPartner from "./CruzeAndPartner";
// import Pricing from "./Pricing";
// import TermsModal from "./TermsModal";
// import ConfirmationModal from "./ConfirmationModal";

import { useParams, useLocation } from "react-router-dom";
import { sendNotificationBidAccepted, sendNotificationBidNotAccepted, sendNotificationPaymentNotAccepted } from "../../utils/functions/notification";
import TripServices from "../../services/externalServices/trip/TripServices";
import CabServices from "../../services/externalServices/cab/CabServices";
import { PersonCount } from "./components";
// import Pricing from "./components/Pricing";
import TermsModal from "./components/TermsModal";
import { useNavigate } from "react-router-dom";
import releaseRidersFromBidLock from "../../utils/functions/riders";
import Pricing from "./components/Pricing";
import ConfirmationModal from "../booking/components/ConfirmationModal";
import PaymentOptions from "../PaymentOptionScreen";
import { TRIP_STATUS } from "../../utils/constants";

const { PAYMENT_URL } = env;

const BookingSummary = () => {
  // const isDarkMode = getTheme().isDarkMode;
  // const theme = isDarkMode ? cssDark : cssLight;
  // const backgroundColor = getTheme().statusbarStyle.backgroundColor;
  // const textColor = getTheme().statusbarStyle.textColor;

  //For Route.Params
  const location = useLocation();
    const { state } = useLocation();
  const routeParams = location.state || {};
  const cabId = routeParams.cabRequestId || null;
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [selectedDate, setSelectedDate] = useState(moment());
  const [selectedTime, setSelectedTime] = useState(new Date());
  const [isFutureDateSelected, setIsFutureDateSelected] = useState(false);
  const [personsCount, setPersonsCount] = useState(null);
  const [selectedCruze, setSelectedCruze] = useState(null);
  const [pickupLocation, setPickupLocation] = useState(null);
  const [bid, setBid] = useState(null);
  const [riderId, setRiderId] = useState(null);
  const [bidFcmTokens, setBidFcmTokens] = useState([]);
  const [bidPhoneNumbers, setBidPhoneNumbers] = useState([]);
  const [acceptedToken, setAcceptedToekn] = useState(null);
  const [pricing, setPricing] = useState([]);
  const [cabRequestId,setCabRequestId]=useState(null);

  const [isCreatingTrip, setIsCreatingTrip] = useState(false);
  const [tripId, setTripId] = useState(null);

  const [isLoading, setIsLoading] = useState(true);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalCancelVisible, setModalCancelVisible] = useState(false);
  const [isBackConfirmed, setIsBackConfirmed] = useState(false);
  const [isMobileLayout, setIsMobileLayout] = useState(
    () => window.innerWidth < 1024,
  );
  const serviceAssociated = "TourPackage";
  const typeOfNotification = "bidCancelled";
  const navigate = useNavigate();

  useEffect(() => {
    const updateLayout = () => setIsMobileLayout(window.innerWidth < 1024);

    window.addEventListener("resize", updateLayout);
    return () => window.removeEventListener("resize", updateLayout);
  }, []);

  // const state = useSelector((state) => state);
  // const { auth } = state;

  useEffect(() => {
    setIsLoading(true);

    if (routeParams) {
      console.log("routeParams============", routeParams);
      const { phone_number, callingModule, doRenderCOD, doRenderUPI } =
        routeParams;
      const {
        title,
        selectedPackage,
        selectedDate,
        selectedTime,
        isFutureDateSelected,
        personsCount,
        selectedCruze,
        pickupLocation,
        bid,
        riderId,
        bidFcmTokens,
        bidPhoneNumbers,
        acceptedToken,
      } = routeParams;

      console.error("accepted and the Bid token", bid, bidFcmTokens);

      setSelectedPackage(selectedPackage);
      setSelectedDate(selectedDate);
      setSelectedTime(selectedTime);
      setIsFutureDateSelected(isFutureDateSelected);
      setPersonsCount(personsCount);
      setSelectedCruze(selectedCruze);
      setPickupLocation(pickupLocation);
      setBid(bid);
      setRiderId(riderId);
      setBidFcmTokens(bidFcmTokens);
      setAcceptedToekn(acceptedToken);
      setBidPhoneNumbers(bidPhoneNumbers);
      setPricing(bid?.pricing);
      setCabRequestId( routeParams?.cabRequestId)
    }

    setIsLoading(false);
  }, [routeParams]);
  console.log("bid in package summary",bid)

  // useEffect(() => {
  //   const handleBackOrForward = () => {
  //     console.log("Back or forward detected. Redirecting...");
  //     navigate("/");  // 🔥 Replace with your desired page
  //   };
  
  //   window.addEventListener("popstate", handleBackOrForward);
  
  //   return () => {
  //     window.removeEventListener("popstate", handleBackOrForward);
  //   };
  // }, [navigate]);

   // ✅ Handle back navigation with confirmation modal

   useEffect(() => {
  const handleBackPress = (event) => {
    // This is crucial: prevent the default back action immediately
    event.preventDefault();
    setModalCancelVisible(true);
  };

  // Push a new state when the component mounts.
  // This helps in detecting the first back press.
  window.history.pushState(window.history.state, "", window.location.pathname);

  // Add the event listener for 'popstate'
  window.addEventListener("popstate", handleBackPress);

  // Clean up the event listener when the component unmounts
  return () => {
    window.removeEventListener("popstate", handleBackPress);
  };
}, [navigate]); // Add navigate to dependency array if it's used inside the effect

const handleBackConfirmation = (confirmed) => {
  setModalCancelVisible(false);
  if (confirmed) {
    handleCancel();
    // After confirmation and handling the cancel,
    // you might want to navigate to a specific safe route
    // instead of relying on the browser's back history.
    // navigate("/"); // Example: navigate to home or a previous safe page
  } else {
    // If the user declines, push a new state again
    // to "re-arm" the popstate listener for future back presses.
    window.history.pushState(window.history.state, "", window.location.pathname);
  }
};
  //  useEffect(() => {
  //   const handleBackPress = (event) => {
  //     event.preventDefault();

  //     // if (!isBackConfirmed) {
  //       setModalCancelVisible(true);
  //       // window.history.pushState(null, "", window.location.pathname);  // Prevent navigation until confirmed
  //     // } else {
  //     //   navigate(-1);  // Navigate back only if confirmed
  //     // }
  //   };
  //    window.history.pushState(null, "", window.location.pathname);

  //   window.addEventListener("popstate", handleBackPress);

  //   // Initial history state push
  //   // window.history.pushState(null, "", window.location.pathname);

  //   return () => {
  //     window.removeEventListener("popstate", handleBackPress);
  //   };
  // }, [ navigate]);

  // // ✅ Handle confirmation of back action
  // const handleBackConfirmation = (confirmed) => {
  //   setModalCancelVisible(false);

  //   if (confirmed) {
  //     handleCancel();
  //     setIsBackConfirmed(true);   // ✅ Set back confirmation flag
  //     // navigate(-1);               // Go back
  //   }
  // };

  // useEffect(() => {
  //   const sendNotification = async () => {
  //     if (!isLoading) {
  //       try {
  //         const filteredTokens = bidFcmTokens.filter((token) => token !== acceptedToken);

  //         console.error('in the notification before');

  //         await sendNotificationBidNotAccepted({
  //           cabRequestId: bid.id,
  //           fcmTokens: filteredTokens,
  //           phoneNumbers: bidPhoneNumbers,
  //           authUser: auth?.user,
  //         });

  //         releaseRidersFromBidLock(bidPhoneNumbers);

  //         console.error('in the notification after');
  //       } catch (err) {
  //         console.error('err in sending notification', err);
  //       }
  //     }
  //   };

  //   sendNotification();
  // }, [isLoading]);

  useEffect(() => {
    const sendNotification = async () => {
      if (!isLoading) {
        try {
          // const filteredTokens = bidFcmTokens.filter((token) => token !== acceptedToken);
          // const filteredTokens = bidFcmTokens.filter((token) => token !== acceptedToken);

          console.error("in the notification before sendNotification");

          createTrip(bid, riderId);

          await sendNotificationBidAccepted({
            cabRequestId: bid.id,
            // fcmTokens: filteredTokens,
            fcmTokens: acceptedToken,
            phoneNumbers: bidPhoneNumbers,
            //   authUser: auth?.user,
          });

          // releaseRidersFromBidLock(bidPhoneNumbers);

          console.error("in the notification after");
        } catch (err) {
          console.error("err in sending notification", err);
        }
      }
    };

    sendNotification();
  }, [isLoading]);


  // const handleBackConfirmation = (confirmed) => {
  //   setModalCancelVisible(false);

  //   if (confirmed) {
  //     handleCancel();
  //   }
  // };

  const callProceedToPayClicked = () => {
    console.warn("selectedPackage == ", selectedPackage);

    try {
      // if (tripId) {

      //   console.log('Trip is already created, just navigating to Payment options: ', tripId);
      //   navigateToPaymentOptions(pricing?.finalAmount, tripId, riderId, bidPhoneNumbers, bid?.cab_request, bidFcmTokens)

      // } else {
      //   setModalVisible(true)
      // }

      setModalVisible(true);
    } catch (error) {
      // ToastAndroid.show("Something went wrong! Please try again later.", ToastAndroid.LONG);
      console.error(
        "Error while deciding to create Trip or navigate to next:",
        error.message
      );
      console.error("Full error details:", error);
    } finally {
    }
  };

  const createTrip = async (bid, riderId) => {
    const tripEndTime = new Date().toISOString();

    setIsCreatingTrip(true);

    try {
      // const data = {
      //   // cabRequestId: cabRequestId,
      //   name: auth.user.first_name,
      //   // pickup_location: pickupLocation?.title,
      //   // drop_location: pickupLocation?.title,
      //   serviceAssociated: serviceAssociated,
      //   typeOfNotification: typeOfNotification,
      //   // selectedPackage: selectedPackage?._id.toString(),
      //   // selectedPackageName: selectedPackage?.detailTitle,
      //   // selectedPackageThumbnail: selectedPackage?.thumbnailImage,
      //   // selectedDate: selectedDate.toString(),
      //   // selectedTime: selectedTime.toString()
      //   // isFutureDateSelected: isFutureDateSelected.toString(),
      //   // personsCount: personsCount.toString(),
      //   // selectedCruze: selectedCruze.id.toString()
      //   // selectedPackageName,
      //   // selectedPackageThumbnail,
      // };

      const payload = {
        rider: riderId,
        cabRequest: bid?.cab_request?.id,
        bid: bid.id,
        // trip_start_time: moment().toISOString()
        trip_start_time: selectedTime,
        status: "INITIATED",
        tripTitle: selectedPackage?.detailTitle,
        pricing: pricing,
        pickupLocation: bid?.cab_request?.pickup_location,
        dropLocation: bid?.cab_request?.drop_location,
        routeCoordinates: bid?.cab_request?.coordinates,
        packageId: selectedPackage?._id.toString(),
        tripThumbnail: selectedPackage?.thumbnailImage,
        tripDate: selectedDate,
        tripTime: selectedTime,
        serviceAssociated: serviceAssociated,
        numberOfPersons: personsCount.toString(),
        // trip_start_time: tripEndTime
        // trip_start_time: "2024-05-30T09:58:59.172Z"
        // trip_start_time: moment(selectedTime)
      };

      console.log(
        "Preparing to create trip with payload:",
        JSON.stringify(payload, null, 2)
      );

      const response = await TripServices.create(payload);

      console.log("Trip creation response:", response);
      // console.log('Trip creation cab requet:', response?.trip?.bid?.cab_request);

      if (response && response?.trip?.id) {
        console.log("Newly Created Trip Id:", response?.trip?.id);

        setTripId(response?.trip?.id);

        // // console.warn('in the bookingsummary', bidFcmTokens)
        // const filteredTokens = bidFcmTokens.filter((token) => token !== acceptedToken);

        // console.warn('filtered token======================', filteredTokens, data);
        // try {

        //   console.error('in the notification before')

        //   await NotificationServices.sendNotification({ fcm_tokens: filteredTokens, data })

        //   console.error('in the notification after')
        // } catch (err) {
        //   console.error('err in sending notification', err)
        // }

        console.warn("Updating cab request Id: ", bid?.cab_request?.id);

        const resp = await CabServices.update(bid?.cab_request?.id, {
          status: "User Accepted",
        });

        console.warn(
          "Response after cab requested updated as User Accepted: ",
          resp
        );

        // navigateToPaymentOptions(pricing?.finalAmount, response?.trip?.id, riderId, bidPhoneNumbers, response?.trip?.cabRequest, bidFcmTokens)
      }
    } catch (error) {
      // ToastAndroid.show("Something went wrong! Please try again later.", ToastAndroid.LONG);
      console.error("Error occurred during Trip creation:", error);
      console.error("Full error details:", error);
    } finally {
      setIsCreatingTrip(false);
    }
  };

  // useEffect(() => {
  //   const handleBackPress = (event) => {
  //     event.preventDefault();
  //     setModalCancelVisible(true);
  //     return false;
  //   };

  //   window.addEventListener("popstate", handleBackPress); // Handle back button in browser

  //   return () => {
  //     window.removeEventListener("popstate", handleBackPress);
  //   };
  // }, []);

  const navigateToPaymentOptions = async (
    amount,
    tripId,
    riderId,
    bidPhoneNumbers,
    cabRequestId,
    bidFcmTokens,
    bid
  ) => {
    console.error("amount ", amount);
    try {
      console.log("Trip Id:", tripId);

      const payload = {
        amount,
        tripid: tripId,
        riderid: riderId,
        callingModule: "TourPackage",
        disableCOD: true,
        disableOnline: false,
        disableCoupon: false,
        bidPhoneNumbers: bidPhoneNumbers,
        cabRequestId: cabRequestId,
        bidFcmTokens: bidFcmTokens,
        bid:bid,
        autoStart: isMobileLayout
      };

      console.log(
        "Navigating to Payment options screen with Payload :",
        JSON.stringify(payload, null, 2)
      );

      navigate("/payment-options", {
        state: payload,
        replace: isMobileLayout,
      }); // Mobile replaces the summary history entry before PhonePe redirect.
    } catch (error) {
      // ToastAndroid.show("Something went wrong! Please try again later.", ToastAndroid.LONG);
      console.error(
        "Error while navigating to Payment Options:",
        error.message
      );
      console.error("Full error details:", error);
    } finally {
    }
  };

  const initiateMobileUpiPayment = async () => {
    setIsCreatingTrip(true);
    try {
      const response = await axios.post(PAYMENT_URL, {
        amount: pricing?.finalAmount,
        mobileNumber: bidPhoneNumbers,
        tripId,
      });
      const data = response.data;

      if (!data.success || !data.data?.instrumentResponse?.redirectInfo?.url) {
        throw new Error("PhonePe payment URL was not returned");
      }

      sessionStorage.setItem("merchantTransactionId", data.merchantTransactionId);
      window.location.replace(data.data.instrumentResponse.redirectInfo.url);
    } catch (error) {
      console.error("Error initiating mobile PhonePe payment:", error);
      alert("Payment initiation failed. Please try again.");
      setIsCreatingTrip(false);
    }
  };

  const handleAccept = () => {
    setModalVisible(false);

    // console.log('In Booking Summary Accept - selectedPackage ', selectedPackage)
    // console.log('In Booking Summary Accept - selectedDate ', selectedDate)
    // console.log('In Booking Summary Accept - selectedTime ', selectedTime)
    // console.log('In Booking Summary Accept - isFutureDateSelected ', isFutureDateSelected)
    // console.log('In Booking Summary Accept - personsCount ', personsCount)
    // console.log('In Booking Summary Accept - selectedCruze ', selectedCruze)
    // console.log('In Booking Summary Accept - pickupLocation ', pickupLocation)
    // console.log('In Booking Summary Accept- bid ', bid)
    // console.log('In Booking Summary Accept - riderId ', riderId)

    // createTrip(bid, riderId);

    // navigateToPaymentOptions(pricing?.finalAmount, response?.trip?.id, riderId, bidPhoneNumbers, response?.trip?.cabRequest, bidFcmTokens)
    if (isMobileLayout) {
      initiateMobileUpiPayment();
      return;
    }

    navigateToPaymentOptions(
      pricing?.finalAmount,
      tripId,
      riderId,
      bidPhoneNumbers,
      bid?.cab_request?.id,
      bidFcmTokens,
      bid
    );
  };

  const handleDecline = () => {
    setModalVisible(false);
  };

  // const handleCancel = () => {
  //   try {
  //     console.log("Cancelling from Booking Summary");
  //     setModalVisible(false);
  //     // navigate(navigationConstants.tourPackage);
  //   } catch (error) {
  //     console.error("Error in handleCancel:", error);
  //   }
  // };
  const goBackToBooking=()=>{
    navigate(-1);
  }

  const handleCancel = async () => {
    try {
      console.info('CANCELLING THE CAB REQUEST SEARCH');

      console.error('fcm tokens=======', bidFcmTokens)

      console.error("bid phone numbers==============", bidPhoneNumbers)
 
      console.log("bid.length",typeof(bid))
      // setWaitingStart(false);
      // setStopSearch(true)

        const tripEndTime = new Date().toISOString();

      const updateData = {
        status: TRIP_STATUS.cancelled,
        trip_end_time: tripEndTime,
        cancelledBy: "user"
      };
     
      // if (bid && Object.keys(bid).length > 0) {
      //   // Run the functions in parallel using Promise.all
        
      //   const [a, b, cabupdate] = await Promise.all([
      //     sendNotificationBidNotAccepted({  cabRequestId , fcmTokens: bidFcmTokens, phoneNumbers: [bidPhoneNumbers] }),
      //     releaseRidersFromBidLock(bidPhoneNumbers),
      //     CabServices.update(cabRequestId, { isLock: true, status: 'Cancel By User' })

      //   ]);
      //   console.error('a, b, c===============', cabupdate);
      // } else {
      //   CabServices.update( cabRequestId, { isLock: true, status: 'Cancel By User' })

      // }


       const [tripUpdateResponse, notificationResponse, releaseResponse] = await Promise.all([
        TripServices.update(tripId, updateData), // First promise

        sendNotificationPaymentNotAccepted({ cabRequestId: bid?.cabRequest?.id, fcmTokens: [acceptedToken], phoneNumbers: [bidPhoneNumbers] }), // Second promise
        releaseRidersFromBidLock([bidPhoneNumbers]), // Third promise
        // If you want to include another service call, you can add it here
        // CabServices.update(cabRequestId, { isLock: true, status: 'Cancel By User' }),
      ]);


      setModalVisible(false);
      goBackToBooking();
    } catch (error) {
      console.error('Error in handleCancel:', error);
    }

  };
//   return (
//     <div className="min-h-screen bg-gray-100 p-4 flex flex-col items-center">
//       {isLoading ? (
//         <div className="flex flex-col items-center justify-center h-screen">
//           <FaSpinner className="animate-spin text-3xl text-gray-700" />
//           <p className="text-lg mt-2 text-gray-700">Loading...</p>
//         </div>
//       ) : (
//         <>
//           <div className="w-full max-w-3xl bg-white shadow-lg rounded-lg p-6">
//             <div className="text-center mb-6">
//               <h2 className="text-2xl font-semibold">Your Booking Summary</h2>
//               <p className="text-gray-500">
//                 Glance over your selections before proceeding
//               </p>
//             </div>
//             <div className="space-y-4 pb-4">
//               {" "}
//               {/* Removed overflow-y-auto and max-h-[70vh] */}
//               <PackageDetails selectedPackage={selectedPackage} />
//               <DateStrip
//                 selectedDate={selectedDate}
//                 selectedTime={selectedTime}
//                 isFutureDateSelected={isFutureDateSelected}
//               />
//               <PickupLocation pickupLocation={pickupLocation} />
//               <PersonCount numPersons={personsCount} />
//               <CruzeAndPartner cruze={bid?.cruzeId} rider={bid?.rider} />
//               {/* <Pricing pricing={pricing} />
//                */}
//                <Pricing pricing={pricing}/>


//             </div>
//           </div>
//           <div className="w-full max-w-3xl mt-6">
//             {isCreatingTrip ? (
//               <div className="flex justify-center py-4 bg-gray-300 rounded-lg">
//                 <FaSpinner className="animate-spin text-2xl text-gray-700" />
//               </div>
//             ) : (
//               <div className="flex justify-between space-x-4 mt-4">
//                 {/* Cancel Button */}
//                 <button
//                   className="flex-1 bg-red-600 text-white py-3 rounded-lg text-lg font-semibold transition hover:bg-red-700"
//                   onClick={()=>setModalCancelVisible(true)}
//                 >
//                   Cancel Booking
//                 </button>

//                 {/* Proceed to Pay Button */}
//                 <button
//                   className="flex-1 bg-black text-white py-3 rounded-lg text-lg font-semibold hover:bg-gray-700 transition"
//                   onClick={callProceedToPayClicked}
//                 >
//                   Proceed to Pay{" "}
//                   {pricing?.finalAmount ? `₹ ${pricing.finalAmount}` : ""}
//                 </button>
//               </div>
//             )}
//           </div>
//         </>
//       )}

//       <TermsModal
//         isVisible={modalVisible}
//         onDecline={handleDecline}
//         onAccept={handleAccept}
//         additionalNote={selectedPackage?.additionalNote}
//       />
//       {/* <TermsModal isVisible={modalVisible} onDecline={handleDecline} onAccept={handleAccept} additionalNote={selectedPackage?.additionalNote} /> */}
//       {/* <ConfirmationModal
//         isVisible={modalCancelVisible}
//         onClose={() => setModalCancelVisible(false)}
//         onConfirm={handleCancel}
//         headingText="Cancel Booking"
//         captionText="Are you sure you want to cancel?"
//         buttonCloseText="No"
//         buttonConfirmText="Yes"
//       /> */}

// {/* {modalCancelVisible && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
//           <div className="bg-white p-6 rounded-lg shadow-lg">
//             <h2 className="text-xl font-semibold">Cancel Booking?</h2>
//             <p>Are you sure you want to cancel and go back?</p>
//             <div className="flex justify-end mt-4">
//               <button
//                 className="bg-gray-300 px-4 py-2 rounded-lg mr-2"
//                 onClick={() => handleBackConfirmation(false)}
//               >
//                 No
//               </button>
//               <button
//                 className="bg-red-600 text-white px-4 py-2 rounded-lg"
//                 onClick={() => handleBackConfirmation(true)}
//               >
//                 Yes
//               </button>
//             </div>
//           </div>
//         </div>
//       )} */}
//        <ConfirmationModal
//         isVisible={modalCancelVisible}
//         title="Cancel Booking?"
//         message="Are you sure you want to cancel and go back?"
//         confirmLabel="Yes"
//         cancelLabel="No"
//         confirmColor="bg-red-600"
//         cancelColor="bg-gray-300"
//         onConfirm={() => handleBackConfirmation(true)}
//         onCancel={() => handleBackConfirmation(false)}
//       />
//     </div>
//   );

return (
  <div className="min-h-screen bg-gray-100 flex justify-center pb-24 lg:p-4 lg:pb-4">
     <div className="flex flex-col lg:flex-row w-full max-w-7xl gap-8 lg:mt-10">
      {/* Left Column: Booking Summary */}
      <div className="w-full lg:w-1/2 bg-white px-4 py-5 lg:shadow-lg lg:rounded-lg lg:p-6 lg:overflow-y-auto">
        {isLoading ? (
          <div className="flex justify-center items-center h-full">
            <FaSpinner className="animate-spin text-3xl text-gray-700" />
          </div>
        ) : (
          <>
            <div className="text-center mb-4 lg:mb-6">
              <h2 className="text-xl font-semibold lg:text-2xl">Your Booking Summary</h2>
              <p className="mt-1 text-sm text-gray-500">Review your selections before proceeding</p>
            </div>

            <div className="space-y-1">
              <PackageDetails selectedPackage={selectedPackage} />
              <DateStrip
                selectedDate={selectedDate}
                selectedTime={selectedTime}
                isFutureDateSelected={isFutureDateSelected}
              />
              <PickupLocation pickupLocation={pickupLocation} />
              <PersonCount numPersons={personsCount} />
              <CruzeAndPartner cruze={bid?.cruzeId} rider={bid?.rider} bid={bid} />
              <Pricing pricing={pricing} />
            </div>

            {/* <div className="flex justify-between mt-6">
              <button
                className="bg-red-600 text-white px-6 py-3 rounded-lg hover:bg-red-700"
                onClick={() => setModalCancelVisible(true)}
              >
                Cancel Booking
              </button>

              <button
                className="bg-black text-white px-6 py-3 rounded-lg hover:bg-gray-700"
                onClick={callProceedToPayClicked}
              >
                Proceed to Pay ₹{pricing?.finalAmount || ""}
              </button>
            </div> */}
          </>
        )}

        {/* Modals */}
        <TermsModal
          isVisible={modalVisible}
          onDecline={handleDecline}
          onAccept={handleAccept}
          additionalNote={selectedPackage?.additionalNote}
        />

        <ConfirmationModal
          isVisible={modalCancelVisible}
          title="Cancel Booking?"
          message="Are you sure you want to cancel and go back?"
          confirmLabel="Yes"
          cancelLabel="No"
          confirmColor="bg-red-600"
          cancelColor="bg-gray-300"
          onConfirm={() => handleBackConfirmation(true)}
          onCancel={() => handleBackConfirmation(false)}
        />
      </div>

      {/* Right Column: Payment Options with Sticky Effect */}
      {!isMobileLayout && (
        <div className="w-full lg:w-1/2 bg-white shadow-lg rounded-lg overflow-y-auto h-fit lg:sticky top-5 max-h-[100vh]">
          <PaymentOptions
            amount={pricing?.finalAmount || 0}
            tripId={tripId}
            riderId={riderId}
            bidPhoneNumbers={bidPhoneNumbers}
            cabRequestId={cabRequestId}
            bidFcmTokens={bidFcmTokens}
            bid={bid}
          />
        </div>
      )}
    </div>

    {isMobileLayout && !isLoading && (
      <div
        className="fixed inset-x-0 bottom-0 z-40 border-t border-gray-200 bg-white px-4 pt-3 shadow-[0_-4px_12px_rgba(0,0,0,0.08)]"
        style={{ paddingBottom: "max(16px, env(safe-area-inset-bottom))" }}
      >
        <button
          type="button"
          disabled={isCreatingTrip}
          onClick={callProceedToPayClicked}
          className="flex w-full items-center justify-center rounded-lg bg-black py-3 text-base font-semibold text-white disabled:cursor-not-allowed disabled:opacity-60"
        >
          {isCreatingTrip ? (
            <FaSpinner className="animate-spin text-xl" />
          ) : pricing?.finalAmount ? (
            `Proceed to Pay ₹ ${pricing.finalAmount}`
          ) : (
            "Proceed to Pay"
          )}
        </button>
      </div>
    )}
  </div>
);

};


export default BookingSummary;
